import axios from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';
import { NewProduct } from '@/types/product';

type GetFishSaleParams = {
	/** ID Продукта */
	product?: number;
	/** Местоположение склада */
	location?: string;
	/** Вид рыбы, ID KindOfFish */
	kind_fish?: number;
	/** Вид разделки, ID CutType */
	type_cutting?: number;
	/** Изготовитель */
	product_manufacturer?: string;
	/** Масса нетто, кг */
	net_weight?: string;
	/** Район промысла TODO: Уточнить после реализации  */
	fishing_area?: string;
	/** Дата изготовления TODO: Уточнить после реализации */
	manufacture_date?: string;
	/** Тара, ID Tare */
	tare?: number;
	/** Вес одного места, кг */
	weight_one_piece?: number;
	/** Cтрана экспорта */
	countries?: number;
	/** Размер рыбопродукции */
	size?: string; // number
	/** Масса нетто, кг */
	volume?: number;

	/** Цена рыбопродукции */
	price?: number; // number

	/** Номер страницы */
	p?: number;
	/** Кол-во элементов на странице */
	page_size?: number;

	/** Показывать все? */
	show?: string;
	/** Locale? */
	lang?: string;

	/** Показывать только продукты компании c определенным id  */
	company_id?: string;
	/** Показывать только продукты на складе с определенным id  */
	warehouse_id?: string;
};

export type GetFishSaleResponse = {
	count: number;
	is_subscribed: boolean;
	results: NewProduct[];
	next: string;
	previous: string;
};

/**
 * Получает список записей о продаже товара
 * @param params Query-параметры
 */
export async function getFishSales(params: GetFishSaleParams) {
	const token = cookies.get(TOKEN_COOKIE_NAME);

	const { data } = await axios.get<GetFishSaleResponse>(`${process.env.HOST}/api_v1/sell-fish/`, {
		params,
		headers: { Authorization: token ? `Bearer ${token}` : null },
	});

	return data;
}
